import { Component, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import $ from "jquery";
import { ProgrammesService } from '../../services/programmes.service';
import { Programme } from '../../models/programme.model';
import { Competence } from '../../models/competence.model';
import { CompetencesModalComponent } from '../programmes/modal/competences.modal.component';


@Component({
  selector: 'app-competences',
  templateUrl: './competences.component.html',
  styleUrls: ['./competences.component.scss']
})
export class CompetencesComponent {
  @Input('competences') competences: Array<Competence>;
  @Input('programme') programme: Programme;

  bsModalRef: BsModalRef;
  public loading: boolean = false;
  myEventSubscription: any;

  constructor(private service: ProgrammesService,
              private modalService: BsModalService) {
  }

  onInit() {
    //this.modalService.onHide.subscribe(() => {
    //  this.service.getCompetencesWithProgrammeId(this.programmeId).subscribe(x => {
    //    this.competences = x;
    //  });
    //});
  }

  openDetailsModal(competence?: any) {
    let initialState = {};
    if (competence) {
      initialState = {
        competence: Object.assign({}, competence),
        programme: this.programme,
      };
    } else {
      initialState = {
        competence: null,
        programme: this.programme,
      };
    }

    this.bsModalRef = this.modalService.show(CompetencesModalComponent, {
      initialState: initialState,
      class: 'gray modal-lg',
      ignoreBackdropClick: true
    });
    this.myEventSubscription =
      this.modalService.onHide.subscribe(() => {
        this.service.getCompetencesWithProgrammeId(this.programme.programmeId).subscribe(x => {
          this.competences = x;
          this.myEventSubscription.unsubscribe();
        });
      });
  }

}
